<template>
  <div id="container">
    <div class="ContainerBox">
      <div class="BoxLeftImgBox">
        <el-skeleton style="border-top-left-radius: 30px;width: 100%;height: 500px" :loading="loading" animated>
          <template slot="template">
            <el-skeleton-item variant="image" style="border-top-left-radius: 30px;width: 100%; height: 500px;" />
          </template>
          <template>
            <img id="promotionalImg" :src="PromotionalPictureSrc" />
          </template>
        </el-skeleton>
      </div>
      <div class="BoxRightLoginBox">
        <div class="TitleBox">
          账号登录
        </div>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm">
          <el-form-item label-width="50px" label="账号" prop="account">
            <el-input v-model="ruleForm.account" autocomplete="off" placeholder="请输入账号" maxlength="20"
              autofocus></el-input>
          </el-form-item>
          <el-form-item label-width="50px" label="密码" prop="password">
            <el-input type="password" v-model="ruleForm.password" autocomplete="off" placeholder="请输入密码" maxlength="18"
              @input="ruleForm.password = ruleForm.password.replace(/[^\w\,]/g, '')"></el-input>
          </el-form-item>
          <img style="width: 100%; height: 30px;margin-bottom: 10px" :src="src" alt="" @click="getCode" />
          <el-form-item prop="captcha">
            <el-input style="width: 100%" v-model="ruleForm.captcha" placeholder="请输入验证码"></el-input>
          </el-form-item>
          <el-form-item>
            <div style="display: flex;">
              <el-checkbox v-model="checked" @change="handleLoginInfo">记住账号密码</el-checkbox>
            </div>

          </el-form-item>
        </el-form>
        <div :class="!loginLoading ? 'login_btn' : 'login_btnClickdisable'" @click="submitForm">
          <i v-if="loginLoading" style="margin-right: 5px" class="el-icon-loading"></i>登录
        </div>
        <div id="reset_btn" style="cursor: pointer" @click="resetForm">重置</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "login",
  created () {
    document.onkeyup = e => {
      if (e.keyCode === 13) {
        this.submitForm('ruleForm');
      }
    }
    if (!(window.history.state && window.history.state.target === 'Final')) {
      window.history.pushState({ target: 'MeanSure', random: Math.random() }, '', window.location.href);
      window.history.pushState({ target: 'Final', random: Math.random() }, '', window.location.href);
    }
    window.addEventListener('popstate', this.test, false);
  },

  beforeRouteLeave (to, from, next) {
    window.removeEventListener('popstate', this.test, false);
    next();
  },

  mounted () {
    document.body.style.overflow = "hidden";
    window.localStorage.removeItem("vuex");
    this.getURLSearchParams()
    this.ShowImg()
    //获取验证码
    this.getCode();
    this.handleCheckRemember()
  },

  data () {
    return {
      checked: false,
      difference: '',
      loading: true,
      PromotionalPictureSrc: '',
      loginLoading: false,
      ruleForm: {  //校验表单
        account: "",
        password: "",
        key: '',
        captcha: ''
      },
      rules: {  //校验规则
        account: [
          { required: true, message: '请输入账号', trigger: 'change' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'change' },
          { min: 6, max: 18, message: '密码在6~18位之间', trigger: 'change' }
        ],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'change' }
        ]
      },
      src: ''
    }
  },

  methods: {

    handleLoginInfo () {
      if (!this.checked) {
        window.localStorage.removeItem('account')
        window.localStorage.removeItem('password')
        window.localStorage.removeItem('remember')
      }
    },

    // 检查是否记住密码
    handleCheckRemember () {
      const remember = window.localStorage.getItem('remember');
      if (remember === null) {
        this.checked = false;
        this.ruleForm.account = '';
        this.ruleForm.password = '';
      } else {
        this.checked = true;
        this.ruleForm.account = window.localStorage.getItem('account');
        this.ruleForm.password = window.localStorage.getItem('password');
      }
    },

    // 获取地址栏code
    getURLSearchParams () {
      // 获取查询字符串（不包括哈希部分）  
      const search = window.location.search;
      // 创建一个新的 URLSearchParams 对象  
      const params = new URLSearchParams(search);
      // 获取 code 参数的值  
      this.difference = params.get('code');
      window.localStorage.setItem('code', this.difference);
    },

    test (e) {  //禁止浏览器回退
      if (e.state && e.state.target === 'MeanSure') {
        // 此处可调用一些自定义的操作，例如弹窗提示之类的
        window.history.forward();
      }
    },

    //获取验证码
    getCode () {
      this.$axios.get("/users/captcha").then((res) => {
        if (res.data.code === 200) {
          this.src = res.data.data.img;
          this.ruleForm.key = res.data.data.key;
        }
      })
    },

    //验证登录信息并登录
    submitForm () {
      this.loginLoading = true
      this.$refs.ruleForm.validate((valid) => {
        /**输入账号信息 */
        if (valid) {

          const ruleForm = {
            account: this.difference + '_' + this.ruleForm.account,
            password: this.ruleForm.password,
            key: this.ruleForm.key,
            captcha: this.ruleForm.captcha
          }

          if (this.checked) {
            window.localStorage.setItem('remember', this.checked)
            window.localStorage.setItem('account', this.ruleForm.account)
            window.localStorage.setItem('password', this.ruleForm.password)
          } else {
            window.localStorage.removeItem('account')
            window.localStorage.removeItem('password')
            window.localStorage.removeItem('remember')
          }

          this.$axios.post("/users/login", ruleForm).then((res) => {
            /**验证码，账号密码错误 */
            if (res.data.code !== 200) {
              console.log("登录失败")
              this.$message.error(res.data.msg);
              this.getCode()
              this.ruleForm.captcha = "";
              this.ruleForm.password = "";
              this.loginLoading = false
            }
            /**验证码，账号密码正确 */
            else if (res.data.code === 200) {
              this.$store.commit('setToken', res.data.data); //获取token
              window.localStorage.setItem("token", res.data.data); //先手动存储token到localstorage
              this.$axios.get("/users/currentUser?token=" + this.$store.state.token).then((res) => { //利用token查询个人信息
                /**成功登录并获取信息 */
                if (res.data.code === 200) {
                  this.$store.commit('setUserInfo', res.data.data);
                  /*******************根据角色id获得系统的用户的系统权限****************************/
                  this.$axios.get("/roles/sysPower?role_id=" + this.$store.state.userInfo.rid).then((res) => {//
                    if (res.data.code === 200) {
                      this.$store.commit('setSysPower', res.data.data);//获取sysPower
                    }
                    else {
                      this.$message.error("获取系统权限失败");
                      this.loginLoading = false
                    }
                  }).catch((err) => {
                    if (err.response.status === 500) {
                      this.$message.error("网络异常，请检查网络后重试！");
                    } else {
                      this.$message.error("系统繁忙，请稍后重试！");
                    }
                    this.loginLoading = false
                  })
                  /********************************************/
                  /**获得用户的所有角色 */
                  this.$axios.get("/users/getUserRoles?user_id=" + this.$store.state.userInfo.id).then((res) => {
                    if (res.data.code == 200) {
                      this.$store.commit('setRoles', res.data.data)
                    }
                    else {
                      this.$message.error("获取所有角色失败");
                      this.loginLoading = false
                    }
                  }).catch((err) => {
                    if (err.response.status === 500) {
                      this.$message.error("网络异常，请检查网络后重试！");
                    } else {
                      this.$message.error("系统繁忙，请稍后重试！");
                    }
                    this.loginLoading = false
                  })
                  /********************************************/
                  /**********仪表板和绩效审核系统 ***************/
                  let r1 = new Promise((resolve, reject) => {
                    this.$axios.get("/roles/getRoleById?id=" + this.$store.state.userInfo.rid).then((res) => {//根据登录的默认角色登录系统
                      if (res.data.code === 200) {
                        this.$store.commit('setRole', res.data.data);
                        resolve();
                      }
                      else {
                        reject();
                      }
                    }).catch(() => {
                      reject();
                    })
                  })
                  Promise.all([r1]).then(() => {
                    if (this.$store.state.sysPower.id === '2') {
                      this.$router.replace({ path: '/watchDashboard' });
                    }
                    else {
                      this.$router.replace({ path: "/home" });
                    }
                    window.localStorage.removeItem("token"); //登录后清除手动存储的token
                    this.$message.success("登录成功！");
                    this.loginLoading = false;
                  }).catch(() => {
                    this.$message.error("信息获取失败！");
                    this.loginLoading = false
                  })
                  /*************************************************/
                }
                /**身份信息获取失败 */
                else {
                  this.$message.error("系统繁忙，请稍后重试！");
                  this.loginLoading = false
                }
              }).catch((err) => {
                if (err.response.status === 500) {
                  this.$message.error("网络异常，请检查网络后重试！");
                } else {
                  this.$message.error("系统繁忙，请稍后重试！");
                }
                this.loginLoading = false
              });
            }
          }).catch((err) => {
            if (err.response.status === 500) {
              this.loginLoading = false
              this.$message.error("网络异常，请检查网络后重试！");
            } else {
              this.$message.error("系统繁忙，请稍后重试！");
            }
          })
        }
        /**未输入账号信息 */
        else {
          this.$message.error("请正确输入用户名和密码");
          this.ruleForm.password = "";
          this.ruleForm.captcha = "";
          this.loginLoading = false
          this.getCode();
          return false;
        }
      });
    },

    //重置表单
    resetForm () {
      this.$refs.ruleForm.resetFields();
    },

    //前端获取后端二进制图片展示
    ShowImg () {
      this.$axios.get("/picture/selectAll?tenantId=" + this.difference).then((res) => {
        if (res.data.code === 200) {
          if (res.data.data !== null) {
            this.PromotionalPictureSrc = res.data.data.imageUrl
          }
          else {
            this.$message.error("加载图片失败！")
          }
        }
        else {
          this.$message.error("加载图片失败！")
        }
        this.loading = false
      }).catch((err) => {
        if (err.response.status === 500) {
          this.$message.error("网络异常，请稍后重试！");
        }
        else {
          this.$message.error("系统繁忙，请稍后重试！");
        }
        this.loading = false
      })
    },
  },
}
</script>

<style scoped>
#container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  min-width: 1100px;
  min-height: 700px;
}

.ContainerBox {
  display: flex;
  flex-direction: row;
  width: 1000px;
  height: 500px;
  background-color: white;
  border-top-left-radius: 30px;
  border-bottom-right-radius: 30px;
  box-shadow: 15px 15px 20px 3px #4a6081;
}

.BoxLeftImgBox {
  height: 100%;
  width: 60%;
  border-top-left-radius: 30px;
}

.BoxLeftImgBox img {
  height: 100%;
  width: 100%;
  border-top-left-radius: 30px;
}

.TitleBox {
  height: 60px;
  width: 100%;
  line-height: 60px;
  font-weight: 700;
  font-size: 35px;
  margin: 0px 0px 20px 0px;
}

.BoxRightLoginBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 30%;
  padding: 0px 5%;
}

.login_btn {
  width: 100%;
  height: 45px;
  text-align: center;
  color: white;
  font-weight: 700;
  line-height: 45px;
  background-color: #16253E;
  padding: 1px;
  margin-bottom: 10px;
  border-radius: 8px;
  cursor: pointer;
}

.login_btnClickdisable {
  width: 100%;
  height: 45px;
  text-align: center;
  color: white;
  font-weight: 700;
  line-height: 45px;
  background-color: #16253E;
  padding: 1px;
  margin-bottom: 10px;
  border-radius: 8px;
  pointer-events: none;
}

#reset_btn {
  width: 100%;
  height: 45px;
  font-weight: 700;
  line-height: 45px;
  text-align: center;
  color: #16253E;
  border-radius: 8px;
  border: 1px solid #16253E;
}

.login_btn:active {
  font-size: 14px;
}

.login_btn:hover {
  background-color: #396386;
}

#reset_btn:active {
  font-size: 14px;
}

#reset_btn:hover {
  background-color: #F4F5F9;
}
</style>
